import React, { useState, useEffect, useCallback } from 'react'
import {NavLink, useNavigate} from "react-router-dom";
import {
    AUTH_PAGE,
    getAvailableRoutes
} from "../../../utils/js/Const";

import "./StyleButtonBergerMenu.css"
import "../buttonDarMode/StyleButDarckMode.css"

import ButDarkMode from "../buttonDarMode/ButDarkMode";
import logoutSVG from "../../header/img/logout.svg"
import {HandySvg} from "handy-svg";
import {decodeTokens, deleteCookie} from "../../../utils/js/request";

export default function BurgerMenu({ isOpen, onClick, productOffersCount, claimsCount, ordersCount }) {
    decodeTokens();
    const navigate = useNavigate();

    const [availableRoutes, setAvailableRoutes] = useState([]);

    const updateAvailableRoutes = useCallback(() => {
        const role = localStorage.getItem('ROLE');
        try {
            const rolesJson = localStorage.getItem('USER_ROLES');
            let parsedRoles = [];
            if (rolesJson) {
                parsedRoles = JSON.parse(rolesJson);
            }
            const routes = getAvailableRoutes(parsedRoles, role);
            setAvailableRoutes(routes);
        } catch (e) {
            console.error('Ошибка парсинга ролей:', e);
        }
    }, []);

    useEffect(() => {
        updateAvailableRoutes();
        window.addEventListener('storage', updateAvailableRoutes);
        return () => window.removeEventListener('storage', updateAvailableRoutes);
    }, [updateAvailableRoutes]);

    const Logout = async () => {
        localStorage.clear();
        sessionStorage.clear();
        deleteCookie("access_token");
        await new Promise((resolve) => setTimeout(resolve, 1000));
        navigate(AUTH_PAGE);
    };

    return (
        <nav className={`burger__menu ${isOpen ? 'openMenu' : ''} visible-mobile`}>
            <ul className='burger__menu-list'>
                {availableRoutes.map((route, index) => (
                    <li key={route.path} className='burger__menu-item'>
                        <NavLink onClick={onClick} className="burger__menu-link" to={route.path}>
                            {route.name}
                        </NavLink>
                        {productOffersCount > 0 && index === 3 ?(
                            <div className={"burger__menu__count"}>
                                {productOffersCount}
                            </div>
                        ) : ""}
                        {claimsCount > 0 && index === 4 ?(
                            <div className={"burger__menu__count"}>
                                {claimsCount}
                            </div>
                        ) : ""}
                        {ordersCount > 0 && index === 5 ? (
                            <div className={"burger__menu__count"}>
                                {ordersCount}
                            </div>
                        ) : ""}
                    </li>
                ))}
                <li className='burger__menu-item' onClick={Logout}>
                    <div className="header--logout--svg" onClick={onClick}>
                        Выйти
                        <HandySvg src={logoutSVG} style={{width: "2rem", height: "2rem"}} className="butExet"/>
                    </div>
                </li>
            </ul>
            <ButDarkMode/>
        </nav>
    );
}

